/**
 * web/src/hooks/queries/useAccessMatrix.ts
 * GET /api/admin/access — admin User Access matrix payload. Long staleTime
 * because the matrix changes only on explicit admin toggles; the toggle
 * mutation invalidates this key directly.
 */
import { useQuery } from '@tanstack/react-query';
import { fetchAccessMatrix } from '../../api/access';
import { qk } from '../../lib/queryKeys';

/**
 * Fetches the User Access matrix. Returns React Query result over
 * AdminAccessMatrix (users + events + eventGrants).
 *
 * @sideEffects HTTP GET
 * @idempotent yes
 */
export function useAccessMatrix() {
  return useQuery({
    queryKey: qk.adminAccess(),
    queryFn: fetchAccessMatrix,
    staleTime: 5 * 60_000,
  });
}
